import { apolloProvider } from '@/apollo-provider.js'
import { QUERY_HOTSITE_SLOTS } from './graphql'
import cloneDeep from 'lodash/cloneDeep'

export default {
  async queryHotsiteSlots({ commit }) {
    await apolloProvider.defaultClient
      .query({
        query: QUERY_HOTSITE_SLOTS,
        fetchPolicy: 'no-cache',
      })
      .then(({ data: { hotsiteSlots: { slots } = [] } }) => {
        commit('SET_HOTSITE_SLOTS', cloneDeep(slots))
      })
  },
}
